export const SPANISH_MONTH_NAMES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
] as const;

export const SPANISH_MONTH_MAP: Readonly<Record<string, number>> = {
  ene: 1,
  feb: 2,
  mar: 3,
  abr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  ago: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dic: 12,
};

export const SPANISH_MONTH_DISPLAY_MAP: Readonly<Record<string, string>> = {
  ene: 'Ene',
  feb: 'Feb',
  mar: 'Mar',
  abr: 'Abr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  ago: 'Ago',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dic: 'Dic',
};

export function parseSpanishMonthKey(monthStr: string): number {
  const [monthName, year] = monthStr.split('-');
  const monthNum = SPANISH_MONTH_MAP[monthName?.toLowerCase() || ''] || 0;
  const yearNum = parseInt(year || '0', 10);
  return yearNum * 100 + monthNum;
}

export function twoDigitYearToFull(twoDigitYear: number): number {
  return twoDigitYear < 50 ? 2000 + twoDigitYear : 1900 + twoDigitYear;
}

export function isSpanishMonthInFuture(monthKey: string): boolean {
  const [monthName, yearStr] = monthKey.split('-');
  const monthNum = SPANISH_MONTH_MAP[monthName?.toLowerCase() || ''] || 0;
  const yearNum = parseInt(yearStr || '0', 10);
  const fullYear = twoDigitYearToFull(yearNum);

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  if (fullYear > currentYear) return true;
  if (fullYear === currentYear && monthNum >= currentMonth) return true;
  return false;
}

export function isSpanishMonthStrictlyInFuture(monthKey: string): boolean {
  const [monthName, yearStr] = monthKey.split('-');
  const monthNum = SPANISH_MONTH_MAP[monthName?.toLowerCase() || ''] || 0;
  const yearNum = parseInt(yearStr || '0', 10);
  const fullYear = twoDigitYearToFull(yearNum);

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  if (fullYear > currentYear) return true;
  if (fullYear === currentYear && monthNum > currentMonth) return true;
  return false;
}

export function formatSpanishMonthForDisplay(monthKey: string): string {
  const monthName = monthKey.split('-')[0];
  return SPANISH_MONTH_DISPLAY_MAP[monthName?.toLowerCase() || ''] || monthName;
}
